import { Icon, IconButton } from '@faststore/ui'
import React from 'react'

import { alertStyles } from './alertStyles'
import AlertCloseIcon from '../../../../assets/AlertCloseIcon'
import ErrorIcon from '../../../../assets/ErrorIcon'
import { InfoIcon } from '../../../../assets/InfoIcon'
import SuccessIcon from '../../../../assets/SuccessIcon'
import '../newsletter.scss'

export interface Status {
  mensage?: string
  sucess: boolean
  error?: boolean
  info?: boolean
}

interface AlertProps {
  setStatus: (value: Status) => void
  status: Status
  loading?: boolean
}

const AlertCustom = ({ setStatus, status, loading }: AlertProps) => {
  const { containerBackground, textColor, iconColor } = alertStyles(status)

  return (
    <div
      className="alert-newletter"
      style={{
        backgroundColor: containerBackground,
      }}
    >
      <div className="alert-newletter-text-icon">
        {status.sucess ? (
          <Icon component={status.info ? <InfoIcon /> : <SuccessIcon />} />
        ) : (
          <Icon component={<ErrorIcon />} />
        )}
        <span
          className="text-newletter"
          style={{
            color: textColor,
          }}
        >
          {' '}
          {status.mensage}
        </span>
      </div>
      <IconButton
        onClick={() => setStatus({ sucess: false })}
        className="icon-button-newletter"
        disabled={loading}
        icon={<AlertCloseIcon color={iconColor} />}
        aria-label="close icon"
      />
    </div>
  )
}

export default AlertCustom
